import { useMemo } from 'react';

import { PERMISSIONS, usePlatformAuthorization } from '@/lib/auth';

export const useCNMCPermissions = () => {
  const { hasPlatformPermission } = usePlatformAuthorization();

  const { canCreate, canUpdate, canDelete } = useMemo(
    () => ({
      canCreate: hasPlatformPermission([PERMISSIONS.MEDIA_MANAGER.CREATE_CNMC_REPORT]),
      canUpdate: hasPlatformPermission([PERMISSIONS.MEDIA_MANAGER.CREATE_CNMC_REPORT]),
      canDelete: hasPlatformPermission([PERMISSIONS.MEDIA_MANAGER.DELETE_CNMC_REPORT]),
    }),
    [hasPlatformPermission]
  );

  return {
    canCreate,
    canUpdate,
    canDelete,
  };
};
